var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.row)?_c('popup-data',{attrs:{"feature":_vm.row,"fields":_vm.fields,"render-contents":_vm.tooltipTemplate}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }